import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=1b20d622&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=1b20d622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b20d622",
  null
  
)

export default component.exports